import * as R from 'ramda';
import React, { useEffect, useState } from 'react';
// helpers/constants
import * as G from '../helpers';
// utilities
import { sendRequest } from '../utilities/http';
import endpointsMap from '../utilities/endpoints';
//////////////////////////////////////////////////

const useAsyncCloEvents = (cloGuid) => {
  const [asyncEvents, setAsyncEvents] = useState(null);

  useEffect(() => {
    const getCloEventsRequest = async () => {
      const params = { cloGuid };

      const res = await sendRequest('get', endpointsMap.cloEventList, { params });

      const { data, status } = res;

      if (G.isResponseSuccess(status)) {
        setAsyncEvents(R.or(data, []));
      } else {
        G.handleFailResponseSimple(
          res,
          false,
          'withAsyncCloEvents -> getCloEventsRequest',
        );
      }
    };

    getCloEventsRequest();
  }, []);

  return asyncEvents;
};

export const withAsyncCloEvents = (Component) => (props) => {
  const { cloGuid } = props;

  const asyncEvents = useAsyncCloEvents(cloGuid);

  return <Component {...props} asyncEvents={asyncEvents} />;
};
